import { safeJsonParse } from '.';
import { getBasicConfig } from '@/apis/ducc/ducc.api';
import FeedbackTypeEnum from '@/app/feedback/components/feedbackType';

const getShowEntrance = async (feedbackType: FeedbackTypeEnum): Promise<boolean> => {
  const duccData = await getBasicConfig();
  // console.log('==========duccData===========', duccData);
  const { feedback_entrance_config } = duccData?.data?.configMap || {};
  if (feedback_entrance_config) {
    const config = safeJsonParse(feedback_entrance_config);
    if (config && config.data && config.data.includes(feedbackType)) {
      return false;
    }
  }
  return true;
};

export default getShowEntrance;
